import { FC } from "react";
import moment from "moment";

import { useTimer } from "hooks";

interface CountdownProps {
  endTime: string;
  onEndTimeReached: () => void;
}

const Countdown: FC<CountdownProps> = ({ endTime, onEndTimeReached }) => {
  const now = useTimer();

  const timeLeft = moment.duration(moment(endTime).diff(moment(now)));
  const hasTimeLeft =
    timeLeft.days() > 0 ||
    timeLeft.hours() > 0 ||
    timeLeft.minutes() > 0 ||
    timeLeft.seconds() > 0;
  if (!hasTimeLeft) {
    onEndTimeReached();
  }

  const daysLeftDisplay = timeLeft.days() > 0 ? `${timeLeft.days()} days ` : "";

  return hasTimeLeft ? (
    <>
      {daysLeftDisplay}
      {timeLeft.hours()}&nbsp;hours&nbsp;{timeLeft.minutes()}&nbsp;min
    </>
  ) : (
    <>—</>
  );
};

export default Countdown;
